import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-go",
  "use": "icon-go-usage",
  "viewBox": "0 0 11 10",
  "content": "<symbol viewBox=\"0 0 11 10\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-go\">\n<path d=\"M0 4.33331L7.72386 4.33331L4.72386 1.33331L5.66667 0.390503L10.2761 4.99998L5.66667 9.60945L4.72386 8.66664L7.72386 5.66664L1.77491e-07 5.66665L0 4.33331Z\" fill=\"#232323\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol